import React, { Fragment } from 'react';
import HeroComponent from '../components/home_v2/hero_component';
import PageHelmet from '../components/common/PageHelmet';

export default function HomeScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="Rubaai - Leading Digital Payment Solutions"
                description="Discover Rubaai's innovative digital payment platform. Secure, fast, and reliable payment solutions for businesses and individuals. Experience seamless transactions with cutting-edge technology."
                keywords="digital payments, payment gateway, online payments, mobile payments, fintech, payment solutions, Rubaai, secure payments, fast transactions"
            />
            <HeroComponent />
        </Fragment>
    );
}
